import { QuizDto } from './quiz.dto';

export class Quiz {
    readonly id: string;
    readonly name: string;
    readonly questionIds: string[];

    constructor(dto: QuizDto) {
        this.id = dto.id;
        this.name = dto.name ?? '';
        this.questionIds = dto.questionIds;
    }

    get questionCount(): number {
        return this.questionIds.length;
    }
}
